import styled from "styled-components";

const Button = styled.button`
  padding: 1em 2.5em;
  font-size: ${({ small }) => small ? '1em' : '1.2em'};
  font-weight: bold;
  border-radius: 5px;
  background: ${({ background }) => background ?  background: '#7E99CD'};
  color: ${({ color }) => color ?  color: 'white'};
  border: none;
  cursor: pointer;
  &:focus{
    outline:0;
  }
`;

export default Button;
